import styled from 'styled-components'

// 버튼 기본설정
export const Button = styled.button`
  color: var(--colBlack);
  background: transparent;
  border: none;
  cursor: pointer;
`

// 검정색 배경 버튼 기본설정
export const BlackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--colWhite);
  background: var(--colBlack);
  border: none;
  cursor: pointer;
`

// 프로필 버튼 영역
export const ProfileArea = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
`

// 상단 헤더 버튼
export const BtnHeaderIcon = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 48px;
  & img {
    width: 24px;
    height: 24px;
  }
`

// 상단 프로필 버튼
export const BtnHeaderProfile = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  padding: 10px;
`

// 상품목록 헤더 옵션(정렬, 필터) 버튼
export const BtnOption = styled(Button)`
  height: 32px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
  }
`

// 상품목록 헤더 - 상품목록 타입(썸네일형, 목록형) 선택 버튼
export const BtnListType = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin: 0;
  padding: 0;
  cursor: pointer;
  & img {
    width: 100%;
    height: 100%;
  }
`
// 찜하기 버튼
export const BtnLike = styled(Button)`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 6px;
  border-radius: 4px;
  background: var(--colWhite);
  border: 1px #e9e9e9 solid;
  z-index: 3;
`

// 장바구니 전체삭제 버튼
export const BtnCartAllDelete = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  & img {
    width: 20px;
    height: 20px;
  }
  & .allDelete {
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: var(--colBlack);
  }
`

// 장바구니 상품삭제 버튼
export const BtnCartItemDelete = styled(Button)`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px #e8e8e8 solid;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: var(--colBlack);
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    height: 48px;
    color: var(--colBlack);
  }
`

// 장바구니 결제버튼
export const BtnCartPayment = styled(Button)`
  width: 100%;
  height: 48px;
  background: var(--colBlack);
  color: var(--colWhite);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  border-radius: 5px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    height: 56px;
  }
`
// 상품 상세페이지 아이콘 버튼
export const BtnDetailIcon = styled(Button)`
  padding: 12px;
  font-size: 0;
  & img {
    width: 24px;
    height: 24px;
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

// 상품 상세페이지 쿠폰다운로드 버튼
export const BtnCouponDownload = styled(BlackButton)`
  gap: 4px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  border-radius: 4px;
  & img {
    width: 20px;
    height: 20px;
  }
`

// 배경색이 블랙인 버튼
export const BtnBlack = styled(Button)`
  padding: 12px 14px;
  background-color: var(--colBlack);
  color: white;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`

// 하단 fixed 버튼
export const BtnFixed = styled(Button)`
  background-color: var(--colBlack);
  height: 48px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: white;
  width: 100%;
  border-radius: 5px;
  z-index: 20;
  transition: background 0.2s, color 0.2s;
  &:disabled {
    background-color: var(--colGray3);
    color: var(--colGray6);
    cursor: not-allowed;
    pointer-events: none;
    opacity: 1;
  }
  &:focus {
    background: #23272f;
    color: var(--colWhite);
    outline: 2px solid #4b4b4b;
    outline-offset: 2px;
    box-shadow: 0 0 0 4px rgba(25, 118, 210, 0.12);
  }

  @media screen and (min-width: 768px) {
    position: static;
    width: 100%;
    margin: 20px 0 0 0;
  }
`

export const BtnWhiteRounded = styled(Button)`
  padding: 8px 10px;
  border-radius: 37.5px;
  background-color: white;
  border: 1px solid var(--colGray3);
  color: var(--colGray7);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    font-size: 13px;
    padding: 10px 12px;
  }
`

export const BtnGrayRounded = styled(Button)`
  border-radius: 44px;
  padding: 12px 69px;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  height: 44px;
  border: 1px var(--colGray3) solid;
`

export const BtnReviewdLike = styled(Button)<{ islike: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  height: 26px;
  padding: 5px 8px;
  border: 1px solid var(--colGray3);
  border-radius: 18px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  background: ${(props) => (props.islike === 'true' ? 'var(--colBlack)' : 'var(--colWhite)')};
  color: ${(props) => (props.islike === 'true' ? 'var(--colWhite)' : 'var(--colBlack)')};
`

export const BtnReviewdUnLike = styled(Button)<{ isunlike: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  padding: 5px 8px;
  border: 1px solid var(--colGray3);
  border-radius: 18px;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  background: ${(props) => (props.isunlike === 'true' ? 'var(--colBlack)' : 'var(--colWhite)')};
  color: ${(props) => (props.isunlike === 'true' ? 'var(--colWhite)' : 'var(--colBlack)')};
`

// 더보기 버튼
export const BtnMore = styled(Button)<{ ismore: string }>`
  color: var(--colGray6);
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-left: 10px;
  padding: 0;
`

// 홈모듈 더보기 버튼
export const BtnHomeModuleMore = styled(BtnWhiteRounded)`
  width: 217px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  margin: 0 18px;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 44px;
  border: none;
  @media screen and (min-width: 768px) {
    width: 240px;
    height: 48px;
    padding: 14px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    border-radius: 54px;
  }
`
